import { render, staticRenderFns } from "./TheHowItWorksLayout.vue?vue&type=template&id=57db3834&scoped=true"
import script from "./TheHowItWorksLayout.vue?vue&type=script&lang=js"
export * from "./TheHowItWorksLayout.vue?vue&type=script&lang=js"
import style0 from "./TheHowItWorksLayout.vue?vue&type=style&index=0&id=57db3834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db3834",
  null
  
)

export default component.exports